<template>
  <div style="padding: 10px;">
    <div style="white-space: pre-wrap;text-align: center;font-size: 16pt;">
      浙海大一卡通信息绑定
    </div>
    <div style="text-align: left;">
      <van-field
        v-model="phone"
        type="tel"
        maxlength="11"
        label="手机号"
        placeholder="请输入手机号"
      />
      <van-field
        v-model="verifyCode"
        type="digit"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
        maxlength="6"
      >
        <template #button>
          <van-button
            size="small"
            type="primary"
            color="#46C9BA"
            v-on:click="sendVerifyCode"
            >发送验证码</van-button
          >
        </template>
      </van-field>
      <van-field
        v-model="stuInfo"
        maxlength="30"
        label="学生学号"
        placeholder="请输入学生学号"
      />
      <van-field
        v-model="stuName"
        label="学生姓名"
        placeholder="请输入学生姓名"
      />

      <div style="padding-top: 35px;"></div>
      <van-button
        type="primary"
        color="#46C9BA"
        block
        v-on:click="verifyAccount"
        >验证信息并绑定</van-button
      >
      <div style="padding-top: 20px;"></div>
      <div
        style="white-space: pre-wrap;text-align: left;font-size: 10pt;color:red;"
      >
        注意事项： 1、本功能 仅限浙海大师生绑定一卡通信息。
        2、未绑定账户可能无法正常使用。
      </div>
    </div>
    <div style="white-space: pre-wrap;text-align: center;">
      <van-list @load="onLoad"></van-list>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: "",
      verifyCode: "",
      stuInfo: "",
      stuName: ""
    };
  },
  methods: {
    onLoad: function() {
      console.log("onload...");
    },
    sendVerifyCode() {
      if (this.phone == null || this.phone.length != 11) {
        this.$toast.fail("手机号格式不正确!");
        return;
      }

      let data = new FormData();
      data.append("phone", this.phone);

      this.$axios
        .post("/api/useraccountbind/send-verifycode", data)
        .then(res => {
          if (res.data.success) {
            this.$toast.success("验证码发送成功!");
          } else {
            this.$toast.fail("操作失败，原因：" + res.data.msg + "!");
          }
        })
        .catch(error => {
          this.$toast.fail("操作失败!");
        });
    },

    verifyAccount() {
      if (this.phone == null || this.phone.length != 11) {
        this.$toast.fail("手机号格式不正确!");
        return;
      }

      if (this.verifyCode == null || this.verifyCode.length != 6) {
        this.$toast.fail("请输入正确的短信验证码!");
        return;
      }

      if (this.stuInfo == null) {
        this.$toast.fail("请输入学生学号!");
        return;
      }

      if (this.stuName == null) {
        this.$toast.fail("请输入学生姓名!");
        return;
      }

      let data = new FormData();
      data.append("phone", this.phone);
      data.append("verifyCode", this.verifyCode);
      data.append("stuInfo", this.stuInfo);
      data.append("stuName", this.stuName);

      this.$axios
        .post("/api/useraccountbind/useraccount-verify", data)
        .then(res => {
          if (res.data.success) {
            this.$dialog.alert({
              title: "提示",
              message: "绑定成功",
              callback: () => {
                this.phone = "";
                this.verifyCode = "";
                this.stuInfo = "";
                this.stuName = "";
              }
            });
          } else {
            this.$toast.fail("验证失败，原因：" + res.data.msg + "!");
          }
        })
        .catch(error => {
          this.$toast.fail("操作失败!");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/user/ZHDUserBind.vue